import { render, staticRenderFns } from "./courseCollection.vue?vue&type=template&id=0a50aa31&scoped=true"
import script from "./courseCollection.vue?vue&type=script&lang=js"
export * from "./courseCollection.vue?vue&type=script&lang=js"
import style0 from "./courseCollection.vue?vue&type=style&index=0&id=0a50aa31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50aa31",
  null
  
)

export default component.exports